const TOOLPAD_CORE_DEFAULT_LOCALE_TEXT = {
  // Account
  signInLabel: 'Sign In',
  signOutLabel: 'Sign Out',
  // Account Preview
  iconButtonAriaLabel: 'Current User'
};
export default TOOLPAD_CORE_DEFAULT_LOCALE_TEXT;